import classes from "./AdTab.module.scss";
import { AdTabProps } from "./config/tab";
import { memo, PropsWithChildren, useCallback } from "react";

const AdTab = ({ link, children }: AdTabProps & PropsWithChildren) => {
  const handleClick = useCallback(() => {
    window.location.href = link;
  }, [link]);

  return (
    <span className={classes.advertTab} onClick={handleClick}>{children}</span>
  );
};

const adTabMemo = memo(AdTab);

export default adTabMemo;
